import * as actions from "../constants/actionTypes";

const initialState = {
    loading: false,
    saving: false
};

export default function cargo(state = initialState, action) {
    let newState = Object.assign({}, state);

    switch (action.type) {
        case actions.LOADING_CARGO_PORT:
            newState.loading = true;
            break;

        case actions.SAVING_CARGO_PORT:
            newState.loading = true;
            newState.saving = true;
            break

        case actions.RECEIVED_CARGO_PORT:
            newState.loading = false;
            newState.current = action.payload
            break

        case actions.SAVED_CARGO_PORT:
            newState.loading = false;
            newState.saving = false;
            break;

        case actions.ERROR_SAVING_CARGO_PORT:
            newState.loading = false;
            newState.saving = false;
            break;

        default: break;
    }
    return newState;
}



// WEBPACK FOOTER //
// ./src/reducers/cargoPort.js